import { Box, Typography } from "@mui/material";
import AcxChip from "components/UI/AcxChip";
import { observer } from "mobx-react";
import React from "react";

type KeyInsightProps = {
    name: string;
    description?: string | null;
};

const KeyInsight: React.FC<KeyInsightProps> = observer(
    ({ name, description }) => (
        <Box sx={{ marginBottom: 1 }}>
            <AcxChip size="small" label={name} color="white" />
            {description && (
                <Typography sx={{ fontWeight: 500, fontSize: "13px" }}>
                    {description}
                </Typography>
            )}
        </Box>
    ),
);

export default KeyInsight;
